import React from 'react';
import { Placeholder } from 'react-bootstrap';
import CardLayout from '../../../../shared/components/card/CardLayout';

const InfoBlock = () => (
    <div className="info-block">
        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide d-block mb-1" />
        <Placeholder className="skeleton skeleton-stat-label d-block" />
    </div>
);

export function InvoiceMainCardLoadingSkeleton() {
    return (
        <CardLayout classBody="contract-list-card px-3 py-0 placeholder-glow">
            <div className="image-wrapper">
                <Placeholder className="skeleton skeleton-fill" />
            </div>
            <div className="card-content pl-2 pl-md-3">
                <Placeholder className="skeleton skeleton-table-name d-block" />
                <Placeholder className="skeleton skeleton-stat-label d-block mt-2" />
            </div>
            <div className="card-info">
                <div className="info-block">
                    <div className="ml-md-2 d-flex align-items-center">
                        <Placeholder
                            className="skeleton skeleton-influencer-avatar"
                            style={{ width: 40, height: 40 }}
                        />
                        <div className="ml-1">
                            <Placeholder className="skeleton skeleton-table-cell d-block mb-1" />
                            <Placeholder className="skeleton skeleton-stat-label d-block" />
                        </div>
                    </div>
                </div>
                <InfoBlock />
                <InfoBlock />
                <InfoBlock />
                <div className="d-flex align-items-center w-md-auto w-100 justify-content-end">
                    <Placeholder
                        className="skeleton skeleton-outline-btn btn-gray mr-2"
                        style={{ width: 30, height: 38 }}
                    />
                    <Placeholder className="skeleton skeleton-action-btn" style={{ width: 90, height: 38 }} />
                </div>
            </div>
        </CardLayout>
    );
}
